import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import Select, { components } from "react-select";

import WP from "WP";

import Arrow from "images/arrowdown.svg";
import Media from "css/Media";
import options from "./countries";

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <StyledArrow isFocused={props.isFocused && !props.hasValue} />
      </components.DropdownIndicator>
    )
  );
};

const StyledArrow = styled.div`
  background-image: url(${Arrow});
  background-repeat: no-repeat;
  background-size: contain;
  width: 10.22px;
  height: 5.45px;
  transition: transform 0.2s ease;

  ${(props) =>
    props.isFocused &&
    css`
      transform: rotate(180deg);
    `}
`;

const CountrySelect = ({ fieldsValidated, onChange, value }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [validated, setValidated] = useState(fieldsValidated);
  const [dropdownValue, setDropdownValue] = useState(value);

  useEffect(() => {
    if (!fieldsValidated) {
      setValidated(dropdownValue ? true : false);
    }
  }, [fieldsValidated]);

  const handleChange = (e) => {
    setDropdownValue(e);
    setValidated(true);
    onChange(e.value);
  };

  const handleBlur = () => {
    setIsFocused(false);
    setValidated(dropdownValue ? true : false);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };
  return (
    <Wrapper>
      <span>{WP.trans.nationality}</span>
      <StyledSelect
        name='country'
        options={options}
        defaultInputValue={value ? dropdownValue.label : ""}
        onChange={handleChange}
        className='select-container'
        classNamePrefix={"select"}
        onFocus={handleFocus}
        onBlur={handleBlur}
        components={{ DropdownIndicator }}
        isFocused={isFocused}
        validated={!fieldsValidated ? (dropdownValue ? 1 : 0) : 1}
      />
      {!validated && (
        <ErrorMessage>
          {WP.trans.invalidBlank}{" "}
          {WP.trans.country ? WP.trans.country.toLowerCase() : "city"}
        </ErrorMessage>
      )}
    </Wrapper>
  );
};

export default CountrySelect;

const Wrapper = styled.div`
  span {
    display: block;
    ${(props) => props.theme.fonts.h6}
    text-decoration: none!important;
    color: ${(props) => props.theme.colors.text}!important;
    cursor: default !important;

    ${Media.greaterThan("s")`
            padding: 0 0 ${(props) => props.theme.spacing.contentM} ${(props) =>
      props.theme.spacing.contentM};
        `}
  }
`;

const StyledSelect = styled(Select)`
  .select {
    &__control {
      position: relative;
      height: ${(props) => props.theme.spacing.elementXS};
      border-radius: 0;
      width: 100%;
      height: ${(props) => props.theme.spacing.elementS};
      border: 1px solid
        ${(props) =>
          !props.validated
            ? props.theme.colors.danger
            : props.theme.colors.input};
      box-shadow: none;
      -webkit-appearance: none;
      border-radius: 0;
      ${(props) => props.theme.fonts.p};
      padding: 0 25px;
      background-color: ${(props) => props.theme.colors.negative};
      transition: border 0.2s ease;
      cursor: pointer;

      &:hover,
      &:focus-within {
        border-color: ${(props) => props.theme.colors.text};
      }
    }

    &__value-container {
      padding: 0;
    }

    &__indicator {
      &-separator {
        display: none;
      }
      svg {
        fill: ${(props) => props.theme.colors.input};
      }
    }

    &__menu {
      box-shadow: none;
      border: 1px solid rgba(51, 51, 51, 0.2);
      border-radius: 0;

      &-list {
        padding: 0;
      }
    }

    &__option {
      &--is-focused {
        background-color: ${(props) => props.theme.colors.bg};

        &:active {
          background-color: ${(props) => props.theme.colors.bg};
          opacity: 0.7;
        }
      }
      &--is-selected {
        background-color: ${(props) => props.theme.colors.bg};
        opacity: 0.7;
      }
    }
  }
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.danger};
  font-size: 14px;
  line-height: 16px;
  padding-top: 16px;

  ${Media.greaterThan("s")`
    font-size: 16px;
  `}
`;
